import React from 'react';
import { Card, CardContent } from '../components/ui/card';

export const SizeChart = () => {
  return (
    <Card className="border-2 border-[#d4af37]/30 shadow-lg mt-4">
      <CardContent className="p-6">
        <h3 className="text-xl font-bold text-[#7d1f3d] mb-4">Size Guide</h3>
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-[#7d1f3d] text-white">
                <th className="border border-gray-300 px-4 py-3 text-left">Size</th>
                <th className="border border-gray-300 px-4 py-3 text-left">US Size</th>
                <th className="border border-gray-300 px-4 py-3 text-left">Bust (inches)</th>
                <th className="border border-gray-300 px-4 py-3 text-left">Waist (inches)</th>
                <th className="border border-gray-300 px-4 py-3 text-left">Hips (inches)</th>
              </tr>
            </thead>
            <tbody>
              <tr className="hover:bg-rose-50">
                <td className="border border-gray-300 px-4 py-3 font-semibold">S</td>
                <td className="border border-gray-300 px-4 py-3">2-4</td>
                <td className="border border-gray-300 px-4 py-3">32-34</td>
                <td className="border border-gray-300 px-4 py-3">24-26</td>
                <td className="border border-gray-300 px-4 py-3">34-36</td>
              </tr>
              <tr className="hover:bg-rose-50">
                <td className="border border-gray-300 px-4 py-3 font-semibold">M</td>
                <td className="border border-gray-300 px-4 py-3">6-8</td>
                <td className="border border-gray-300 px-4 py-3">34-36</td>
                <td className="border border-gray-300 px-4 py-3">26-28</td>
                <td className="border border-gray-300 px-4 py-3">36-38</td>
              </tr>
              <tr className="hover:bg-rose-50">
                <td className="border border-gray-300 px-4 py-3 font-semibold">L</td>
                <td className="border border-gray-300 px-4 py-3">10-12</td>
                <td className="border border-gray-300 px-4 py-3">36-38</td>
                <td className="border border-gray-300 px-4 py-3">28-30</td>
                <td className="border border-gray-300 px-4 py-3">38-40</td>
              </tr>
              <tr className="hover:bg-rose-50">
                <td className="border border-gray-300 px-4 py-3 font-semibold">XL</td>
                <td className="border border-gray-300 px-4 py-3">14-16</td>
                <td className="border border-gray-300 px-4 py-3">38-40</td>
                <td className="border border-gray-300 px-4 py-3">30-32</td>
                <td className="border border-gray-300 px-4 py-3">40-42</td>
              </tr>
              <tr className="hover:bg-rose-50">
                <td className="border border-gray-300 px-4 py-3 font-semibold">2XL</td>
                <td className="border border-gray-300 px-4 py-3">18-20</td>
                <td className="border border-gray-300 px-4 py-3">40-42</td>
                <td className="border border-gray-300 px-4 py-3">32-34</td>
                <td className="border border-gray-300 px-4 py-3">42-44</td>
              </tr>
              <tr className="hover:bg-rose-50">
                <td className="border border-gray-300 px-4 py-3 font-semibold">3XL</td>
                <td className="border border-gray-300 px-4 py-3">22-24</td>
                <td className="border border-gray-300 px-4 py-3">42-44</td>
                <td className="border border-gray-300 px-4 py-3">34-36</td>
                <td className="border border-gray-300 px-4 py-3">44-46</td>
              </tr>
            </tbody>
          </table>
        </div>
        
        <div className="mt-4 p-4 bg-rose-50 rounded-lg">
          <h4 className="font-semibold text-[#7d1f3d] mb-2">How to Measure:</h4>
          <ul className="space-y-2 text-sm text-gray-700">
            <li><strong>Bust:</strong> Measure around the fullest part of your chest</li>
            <li><strong>Waist:</strong> Measure around the narrowest part of your waist</li>
            <li><strong>Hips:</strong> Measure around the fullest part of your hips</li>
          </ul>
          <p className="mt-3 text-xs text-gray-600">
            * If you&apos;re between sizes, we recommend sizing up for comfort
          </p>
        </div>
      </CardContent>
    </Card>
  );
};
